module.exports = __webpack_public_path__ + "static/media/tti_privacy_keeping@2x.00a83efe.png";